var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rose-lega navy darken-2" }, [
    _vm.showTitle || _vm.showFilters
      ? _c(
          "div",
          {
            class: [
              _vm.showTitle
                ? "titolo navy--text text--lighten-2 font-hemi-head"
                : "rose-lega-options-toolbar",
            ],
          },
          [
            _vm.showTitle ? _c("span", [_vm._v("Rose Lega")]) : _vm._e(),
            _vm._v(" "),
            _vm.showFilters
              ? _c(
                  "v-menu",
                  {
                    attrs: {
                      "offset-y": "",
                      left: "",
                      "close-on-content-click": false,
                      "min-width": "280",
                      "max-width": "320",
                      "content-class": "section-options-menu-content",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "section-title-action-btn navy darken-3 navy--text text--lighten-3 px-2",
                                      attrs: {
                                        "x-small": "",
                                        rounded: "",
                                        depressed: "",
                                        title: "Opzioni Rose Lega",
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { "x-small": "" } }, [
                                    _vm._v("tune"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2335441120
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "v-list",
                      {
                        staticClass: "section-options-menu navy darken-1",
                        attrs: { dense: "", dark: "" },
                      },
                      [
                        _c(
                          "v-subheader",
                          { staticClass: "section-options-menu-title" },
                          [_vm._v("\n          Opzioni\n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item",
                          {
                            attrs: { dense: "" },
                            on: {
                              click: function ($event) {
                                _vm.hideInactiveSquadre =
                                  !_vm.hideInactiveSquadre
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-action",
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    dense: "",
                                    "hide-details": "",
                                    readonly: "",
                                    color: "secondary",
                                    "input-value": _vm.hideInactiveSquadre,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Nascondi squadre escluse"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-list-item-subtitle",
                                  {
                                    staticClass: "rose-lega-filter-description",
                                  },
                                  [
                                    _vm._v(
                                      "\n              Nasconde le squadre escluse manualmente dall'amministratore\n              d'asta.\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.showHidePassedSquadreFilter
                          ? _c(
                              "v-list-item",
                              {
                                attrs: { dense: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.hidePassedSquadre =
                                      !_vm.hidePassedSquadre
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        readonly: "",
                                        color: "secondary",
                                        "input-value": _vm.hidePassedSquadre,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v("Nascondi chi esce dall'asta"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-subtitle",
                                      {
                                        staticClass:
                                          "rose-lega-filter-description",
                                      },
                                      [
                                        _vm._v(
                                          "\n              Nasconde chi ha premuto PASSO, non può rilanciare, ha completato\n              il ruolo o non può partecipare per le regole di lega.\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTopScrollbar,
            expression: "showTopScrollbar",
          },
        ],
        ref: "roseLegaScrollTop",
        staticClass: "rose-lega-scroll-top nice-scroll",
        on: { scroll: _vm.syncScrollFromTop },
      },
      [
        _c("div", {
          staticClass: "rose-lega-scroll-spacer",
          style: { width: _vm.scrollWidth + "px" },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "roseLegaHeaderScroll",
        staticClass: "rose-lega-header-scroll",
        on: { scroll: _vm.syncScrollFromHeader },
      },
      [
        _c(
          "div",
          { staticClass: "rose-lega-scroll-content" },
          _vm._l(_vm.squadre, function (squadraItem) {
            return _c(
              "div",
              {
                key: "header_" + squadraItem.id,
                staticClass: "rose-lega-squadra",
              },
              [
                _c("squadra-tavolo", {
                  staticClass: "rose-lega-squadra-summary",
                  attrs: {
                    id: squadraItem.id,
                    size: _vm.squadraTavoloSize,
                    "disable-menu": _vm.disableSquadraMenu,
                    "menu-context": _vm.squadraMenuContext,
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "roseLegaScroll",
        staticClass: "rose-lega-scroll nice-scroll",
        on: { scroll: _vm.syncScrollFromMain },
      },
      [
        _c(
          "div",
          {
            ref: "roseLegaScrollContent",
            staticClass: "rose-lega-scroll-content",
          },
          _vm._l(_vm.squadre, function (squadraItem) {
            return _c(
              "div",
              { key: squadraItem.id, staticClass: "rose-lega-squadra" },
              _vm._l(_vm.ruoli, function (ruolo) {
                return _c(
                  "div",
                  {
                    key: squadraItem.id + "_" + ruolo.ruolo_id,
                    staticClass: "rose-lega-ruolo",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "rose-lega-ruolo-header",
                        class: "rose-lega-ruolo-" + ruolo.ruolo_id,
                        on: {
                          click: function ($event) {
                            return _vm.toggleRuolo(ruolo.ruolo_id)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "rose-lega-ruolo-main pl-1" },
                          [
                            _c("span", [_vm._v(_vm._s(ruolo.abc))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "ruolo-acquisti-label" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.ruoloAcquistiLabel(
                                      squadraItem.acquisti[ruolo.ruolo_id] || 0,
                                      ruolo
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "rose-lega-ruolo-dx" },
                          [
                            _c(
                              "span",
                              { staticClass: "rose-lega-ruolo-spesa-relativa" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.percentualeCrediti(
                                        squadraItem.spese[ruolo.ruolo_id],
                                        squadraItem.budgetEffettivo
                                      )
                                    ) +
                                    "%\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "rose-lega-ruolo-spesa-assoluta" },
                              [
                                _vm._v(
                                  _vm._s(squadraItem.spese[ruolo.ruolo_id] || 0)
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-icon",
                              {
                                staticClass: "white--text rose-lega-chevron",
                                attrs: { "x-small": "" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.isRuoloCollapsed(ruolo.ruolo_id)
                                        ? "keyboard_arrow_right"
                                        : "keyboard_arrow_down"
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.acquistiInEccesso(
                      _vm.maxAcquistiPerRuolo[ruolo.ruolo_id],
                      ruolo
                    )
                      ? _c(
                          "div",
                          { staticClass: "rose-lega-eccedenza warning--text" },
                          [
                            _vm.acquistiInEccesso(
                              squadraItem.acquisti[ruolo.ruolo_id],
                              ruolo
                            )
                              ? _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.acquistiInEccesso(
                                          squadraItem.acquisti[ruolo.ruolo_id],
                                          ruolo
                                        )
                                      ) +
                                      " in eccesso\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(
                      squadraItem.rosaPerRuolo[ruolo.ruolo_id],
                      function (slot, index) {
                        var _obj
                        return !_vm.isRuoloCollapsed(ruolo.ruolo_id)
                          ? _c(
                              "div",
                              {
                                key:
                                  squadraItem.id +
                                  "_" +
                                  ruolo.ruolo_id +
                                  "_" +
                                  index,
                                staticClass: "rose-lega-player",
                                class:
                                  ((_obj = {
                                    empty: !slot || slot.empty,
                                    "optional-empty":
                                      slot && slot.empty && slot.optional,
                                  }),
                                  (_obj[
                                    "rose-lega-player-" + ruolo.ruolo_id
                                  ] = true),
                                  _obj),
                              },
                              [
                                slot && !slot.empty
                                  ? [
                                      _c("maglia-or-flag-plus-nome", {
                                        attrs: { calciatore: slot },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "rose-lega-player-name",
                                          attrs: { title: slot.calciatore },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(slot.calciatore) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      slot.ms
                                        ? _c("main-status", {
                                            attrs: { ms: slot.ms, small: "" },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "rose-lega-price" },
                                        [_vm._v(_vm._s(slot.prezzo))]
                                      ),
                                      _vm._v(" "),
                                      _vm.canEditCalciatoreAssegnato(slot)
                                        ? _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                bottom: "",
                                                left: "",
                                                "offset-y": "",
                                                "content-class":
                                                  "rose-lega-action-menu",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "rose-lega-menu-button",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                                depressed: "",
                                                                color: "white",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "more_vert"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "v-list",
                                                {
                                                  staticClass: "navy darken-2",
                                                  attrs: {
                                                    dense: "",
                                                    dark: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editCalciatore(
                                                            squadraItem.id,
                                                            slot
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-icon",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mode_edit"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "Modifica costo"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeCalciatore(
                                                            squadraItem.id,
                                                            slot
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-icon",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [_vm._v("close")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "Rimetti svincolato"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e()
                      }
                    ),
                  ],
                  2
                )
              }),
              0
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }